import axios from 'axios'
import { supportApiURL } from 'src/supportPortal/services/services'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import {
  getSPDataWithoutParams,
  getSPDataWithParams,
  postSPDataWithoutParams,
} from 'src/supportPortal/services/services'

function authHeaders() {
  const token = localStorage.getItem('token')
  return { Authorization: `Bearer ${token}` }
}

function getResponseMessage(response, fallback) {
  return (
    response?.data?.message ||
    response?.response?.data?.message ||
    response?.message ||
    fallback
  )
}

const BASE = '/api/secure/cc/support/practitioner-invitations'

export async function listPractitionerInvitations({ status, practitionerType } = {}) {
  const params = {}
  if (status) params.status = status
  if (practitionerType) params.practitionerType = practitionerType
  const response =
    Object.keys(params).length > 0
      ? await getSPDataWithParams(BASE, params)
      : await getSPDataWithoutParams(BASE)
  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    return {
      ok: true,
      data: getDataMapFromCommonResponse(response)?.invitations || [],
      rawResponse: response,
    }
  }
  return {
    ok: false,
    data: [],
    message: getResponseMessage(response, 'Unable to load invitations.'),
    rawResponse: response,
  }
}

export async function createPractitionerInvitation(payload) {
  const response = await postSPDataWithoutParams(BASE, payload)
  if (response?.status === 200 && isCommonResponseSuccessfulV2(response)) {
    return {
      ok: true,
      data: getDataMapFromCommonResponse(response)?.invitation || null,
      rawResponse: response,
    }
  }
  return {
    ok: false,
    data: null,
    message: getResponseMessage(response, 'Unable to create invitation.'),
    rawResponse: response,
  }
}

export async function revokePractitionerInvitation(id, reason) {
  // axios.delete used directly because the support service helpers don't expose a DELETE.
  try {
    const params = reason ? { reason } : {}
    const res = await axios.delete(`${supportApiURL}${BASE}/${encodeURIComponent(id)}`, {
      headers: authHeaders(),
      params,
    })
    if (res?.status === 200 && isCommonResponseSuccessfulV2(res)) {
      return { ok: true, data: getDataMapFromCommonResponse(res), rawResponse: res }
    }
    return {
      ok: false,
      data: null,
      message: getResponseMessage(res, 'Unable to revoke invitation.'),
      rawResponse: res,
    }
  } catch (err) {
    return {
      ok: false,
      data: null,
      message: getResponseMessage(err, 'Unable to revoke invitation.'),
      rawResponse: err,
    }
  }
}
